import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints } from "../../constant/Environment";
import { addData, deleteData, getAllData } from "../../Utility/API";
import { Modal, Form, Button, Dropdown } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const PlayertypeBonusConfig = () => {
  const [editData, setEditData] = useState({});

  const [creative, setCreative] = useState("");
  const [showcreative, setShowCreative] = useState("");

  const [name, setName] = useState("");
  const [confValue, setConfValue] = useState("");
  const [minWager, setMinWager] = useState("");
  const [playerCount, setPlayerCount] = useState("");
  const [playerType, setPlayerType] = useState("");
  const [fantasybonus, setFantasyBonus] = useState("");
  const [betbonus, setBetBonus] = useState("");

  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([
    // {
    //   name: "Refer A friend",
    //   sagacoins: 10,
    //   isactive: 1,
    //   goldcoins: 100,
    //   creative: "",
    // },
  ]);

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(6);

  // console.log("excludePackage", excludePackage);

  const [checkboxes, setCheckboxes] = useState({
    isCheckedActive: false,
    isFeature: false,
    isPopular: false,
    isSpecial: false,
  });
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setCreative(file);
      setShowCreative(imageUrl);
      UploadImage(file);
    }
  };

  const UploadImage = (files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    setIsLoading(true);
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setCreative(result.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error", error));
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    // api call
    fetchConfiguration();
  }, []);

  const fetchConfiguration = async () => {
    let url = `${endPoints.api.PLAYERTYPE_BONUS}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleOk = () => {
    if (!playerType || !fantasybonus || !betbonus) {
      ErrorToast("All fields are required");
      return;
    }

    let url = `${endPoints.api.PLAYERTYPE_BONUS_UPDATE}`;

    let payload = {
      id: editData?.id,
      player_type: playerType,
      fantasybonus: fantasybonus,
      betbonus: betbonus,
      isActive: checkboxes.isCheckedActive ? true : false,
    };

    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          fetchConfiguration();
          handleClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  useEffect(() => {
    if (editData?.id) {
      setPlayerType(editData?.player_type || "");
      setFantasyBonus(editData?.fantasybonus || "");
      setBetBonus(editData?.betbonus || "");
      setCheckboxes({
        isCheckedActive: !!editData.isActive,
      });
    } else {
      setPlayerType("");
      setFantasyBonus("");
      setBetBonus("");
      setCheckboxes({
        isCheckedActive: false,
      });
    }
  }, [editData, show]);

  // const handleSwitchChange = (row, param, value) => {
  //   const updatedRow = { ...row, [param]: value == 0 ? true : false };
  //   updateConfiguration(updatedRow);
  // };

  const handleSwitchChange = (row, param, value) => {
    // Only send the necessary fields for update, not the entire row
    const updatedRow = {
      id: row.id,
      player_type: row.player_type,
      fantasybonus: row.fantasybonus,
      betbonus: row.betbonus,
      isActive: !value // Use consistent field name
    };
    updateConfiguration(updatedRow);
  };

  const updateConfiguration = (payload) => {
    let url = `${endPoints.api.PLAYERTYPE_BONUS_UPDATE}`;
    setIsLoading(true);
    console.log("update payload", payload);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          fetchConfiguration();
          handleClose();
        } else {
          ErrorToast(response?.data?.message || "Update failed");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error?.message || "Something went wrong");
      });
  };

  const rowsToDisplay = rows;

  return (
    <>
      <div className="main">
        <Toaster></Toaster>

        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2 heading-table"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                      Player Type Bonus Configuration
                  </h3>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        stickyHeader
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            {/* <TableCell align="center"> Category</TableCell> */}
                            <TableCell align="center"> Player Type</TableCell>
                            <TableCell align="center">fantasy bonus </TableCell>
                            <TableCell align="center">Pool Bonus</TableCell>
                            <TableCell align="center">Active</TableCell>
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                {/* <TableCell align="center">
                                  {row.conf_name}
                                </TableCell> */}
                                <TableCell align="center">
                                  {row?.player_type}
                                </TableCell>
                                {/* <TableCell align="center">
                                  {row?.pool_bonus}
                                </TableCell> */}
                                <TableCell align="center">
                                  {row?.fantasybonus}
                                </TableCell>

                                <TableCell align="center">
                                  {row?.betbonus}
                                </TableCell>

                                <TableCell align="center">
                                  {/* <Switch
                                    // checked={row.isActive !== 0}
                                    checked={row.isactive}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "isactive",
                                        row.isactive
                                      )
                                    }
                                  /> */}
                                  <Switch
                                    checked={row.isActive}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "isactive",
                                        row.isActive
                                      )
                                    }
                                  />
                                </TableCell>

                                <TableCell align="center">
                                  <EditIcon
                                    onClick={() => {
                                      setShow(true);

                                      setEditData(row);
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    <Modal show={show} onHide={handleClose} size="lg">
                      <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                          Manage Configuration
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Group className="mb-3">
                              <Form.Label>Player Type</Form.Label>
                              <Form.Control
                                type="text"
                                readOnly={true}
                                placeholder="Enter player type"
                                value={playerType}
                                onChange={(e) => setPlayerType(e.target.value)}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-6">
                            <Form.Group className="mb-3">
                              <Form.Label>Fantasy Bonus</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Enter Value"
                                value={fantasybonus}
                                onChange={(e) =>
                                  setFantasyBonus(e.target.value)
                                }
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-6">
                            <Form.Group className="mb-3">
                              <Form.Label>Pool Bonus</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Enter bet bonus"
                                value={betbonus}
                                onChange={(e) => setBetBonus(e.target.value)}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-3">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="isCheckedActive"
                                    checked={checkboxes.isCheckedActive}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Active"
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={handleOk}
                          style={{
                            background: "#04631e",
                            borderColor: "#04631e",
                          }}
                        >
                          Apply
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PlayertypeBonusConfig;
